// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"56cc62fb","255":"bf46b098","496":"e3935c67","541":"5de6cd6f","593":"d31fa517","716":"b51ed229","829":"a3d51013","891":"65e55688","897":"096867a6","942":"42090065","975":"77b39773"}[chunkId] + ".chunk.js";
};